import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Button } from "src/core/components/ui/button";
import { RISK_LEVEL_CLASSES } from "src/core/constants/risk";
import { FolderFile } from "src/core/gql/graphql";

type VersionsColumnsProps = {
  t: (key: string) => string;
  onNavigate: (id: string) => void;
};

export const versionsColumns = ({
  t,
  onNavigate,
}: VersionsColumnsProps): ColumnDef<FolderFile>[] => [
  {
    accessorKey: "riskStatus",
    header: t("folder.versions.riskLevel"),
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <div className="flex items-center gap-x-[15px]">
          <span
            className={`w-[16px] h-[16px] rounded-full ${
              RISK_LEVEL_CLASSES[
                (row.original?.riskStatus
                  .globalRiskLevel as unknown as keyof typeof RISK_LEVEL_CLASSES) || "UNDEFINED"
              ]
            }`}
          ></span>
          {t(
            `folder.versions.riskLevels.${row.original?.riskStatus.globalRiskLevel.toLowerCase()}`
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "validationDate",
    header: t("folder.versions.validationDate"),
    enableSorting: false,
    cell: ({ row }) => {
      return format(row.original?.workflowStatus?.lastModification, "dd/MM/yyyy");
    },
  },
  {
    accessorKey: "action",
    header: "",
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <Button variant="actionWithText" onClick={() => onNavigate(row.original.id.toString())}>
          {t("folder.versions.access")}
        </Button>
      );
    },
  },
];
